import React from 'react';

import { Button } from 'antd';
import { ButtonProps } from 'antd/es/button/button';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  display: flex;
  border-radius: 15px;
  font-size: 12px;
  line-height: 1;
  align-items: center;
  box-shadow: 0 2px 4px 0 var(--neutral-colors-white);
`;

const ButtonPill = (props: ButtonProps) => {
  return <StyledButton {...props} />;
};

export default ButtonPill;
